import React from "react";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "../plugin-toolbar-buttons-ids.js";
import { ToolbarButtonSeparator } from "./toolbar-button-separator.js";
const createSeparator = (attributes) => {
  return {
    id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    type: "separator",
    icon: ToolbarButtonSeparator,
    renderer: () => /* @__PURE__ */ React.createElement(ToolbarButtonSeparator, null),
    attributes
  };
};
export {
  createSeparator
};
//# sourceMappingURL=create-separator.js.map
